// Pendiente de revisar
import { ItiBaseDto } from "@/iti-core-react/dtos/iti-base-dto";

export class ConditionClauseResourceDto extends ItiBaseDto {
	public conditionClauseId: number;
	public resourceId: string;
	public conditionClauseLang: string;

	constructor(src?: any) {
		super(src);

		Object.assign(this, src);
	}
}
